import React, { Component } from 'react';
import '../projectmanager/PMWindowedApp.css';
import ScaffoldDesktop from './ScaffoldDesktop';
import PageWrapper from '../shared/PageWrapper';

class ScaffoldApp extends Component {
  render() {
	const { match } = this.props;
	return (
	  <PageWrapper match={match}>
		<div className="PMWindowApp">
		  {this.modes()}
		</div>
	  </PageWrapper>
	);
  }

  modes = () => {
	const { match } = this.props;

	if (match.path.indexOf('/projectmanager/scaffold') > -1) {
	  return <ScaffoldDesktop />
	}

  }
}

export default ScaffoldApp;


// WEBPACK FOOTER //
// ./src/components/scaffold/ScaffoldApp.js